import React from 'react';
import { Box, Heading, Text, Button, VStack } from '@chakra-ui/react';

const CareersHero = () => {
  return (
    <Box
      w="100%"
      minH={{ base: '220px', sm: '300px', md: '400px', lg: '480px', xl: '550px', '2xl': '600px' }}
      bgImage="url('/png/career-hero-section.png')"
      bgSize={{ base: 'cover', md: 'cover', lg: 'cover', xl: 'cover' }}
      bgPosition="center"
      bgRepeat="no-repeat"
      display="flex"
      alignItems="center"
      justifyContent="center"
      position="relative"
      px={{ base: 2, sm: 4, md: 6, lg: 8 }}
      _after={{
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        w: '100%',
        h: '100%',
        bg: 'rgba(24, 41, 32, 0.4)',
        zIndex: 1,
      }}
    >
      <VStack
        spacing={{ base: 3, md: 4 }}
        zIndex={2}
        position="relative"
        textAlign="center"
        w="full"
        px={{ base: 1, sm: 4, md: 0 }}
      >
        <Heading
          as="h1"
          fontSize={{ base: '3xl', md: '5xl', lg: '6xl', xl: '7xl' }}
          color="white"
          fontWeight="bold"
          lineHeight="1.1"
          textShadow="2px 2px 4px rgba(0,0,0,0.3)"
        >
          Build Skills Unlock Careers<br />Dream Big
        </Heading>
        <Text 
          color="white" 
          fontSize={{ base: 'sm', sm: 'md', md: 'xl', lg: '2xl' }}
          textShadow="1px 1px 2px rgba(0,0,0,0.3)"
          maxW={{ base: '90%', md: '80%', lg: '70%' }}
        >
          Build your future with Business Automation discover roles made for you
        </Text>
      </VStack>
    </Box>
  );
};

export default CareersHero; 